import { takeLatest, put, call } from 'redux-saga/effects';

import { findAnimalPelagemCadastro } from '../service';
import {
  FIND_ANIMAL_PELAGEM_CADASTRO,
  FIND_ANIMAL_PELAGEM_CADASTRO_PENDING,
  FIND_ANIMAL_PELAGEM_CADASTRO_SUCCESS,
  FIND_ANIMAL_PELAGEM_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindAnimalPelagemCadastro(action) {
  yield put({ type: FIND_ANIMAL_PELAGEM_CADASTRO_PENDING, id: action.id })

  try {
    const registro = yield call(findAnimalPelagemCadastro, action.id);
    yield put({ type: FIND_ANIMAL_PELAGEM_CADASTRO_SUCCESS, registro: registro })
  } catch (error) {
    yield put({ type: FIND_ANIMAL_PELAGEM_CADASTRO_FAILURE })
  }
}

export default function* watchFindAnimalPelagemCadastro() {
  yield takeLatest(FIND_ANIMAL_PELAGEM_CADASTRO, sagaFindAnimalPelagemCadastro)
}
